import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '@env/environment';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {UtilsInjectable} from '@app/shared';

@Component({
  selector: 'app-pricing-plan',
  templateUrl: './pricing-plan.component.html',
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    SelectDropDownModule
  ],
  styleUrls: ['./pricing-plan.component.scss']
})
export class PricingPlanComponent implements OnInit {
  public pricing_plan: any =
    {
      purchase_id: 0,
      invoice_no: '',
      medicine_ids: [""],
      medicine_id: 0,
      unitprice: [""],
      sellingprice: [""],
      slab_a_per: [""],
      slab_a_amount: [""],
      slab_b_per: [""],
      slab_b_amount: [""],
      slab_c_per: [""],
      slab_c_amount: [""],
      web_per: [""],
      web_amount: [""],
      user_id: '',
      vat: [""],
      flood: [""],
      slab_a_flood: [""],
      slab_b_flood: [""],
      slab_c_flood: [""],
      purchase_details_id: [],
      rate: [""],
      freight: [""],
      search_text: ""
    }

  invoice: any = [""];
  invoice_options: any;
  invoice_data: any;
  item_list: any;
  user_rights: any;
  user_data: any;
  closeResult = "";
  discount_list: any;
  searching = false;
  searchFailed = false;

  constructor(private loaderService: LoaderService,
              private modalService: NgbModal,
              public reportService: ReportService,
              public consultingService: ConsultingService,
              protected utils: UtilsInjectable,
              private toastr: ToastrService) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.listInvoice();
    this.listAllItems();
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.listPurchaseItemsByVendor();
    }
  }

  public listInvoice() {
    this.loaderService.display(true);
    this.consultingService.listPurchaseInvoice().subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.invoice = result['data'];
        this.invoice_options = this.invoice;
        for (let index = 0; index < this.invoice_options.length; index++) {
          if (this.invoice_options[index].PURCHASE_ID == this.pricing_plan.purchase_id) {
            this.invoice_data = this.invoice_options[index];
          }
        }
      }
    });
  }

  public listPurchaseItems() {
    const postData = {
      invoice_no: this.invoice_data.INVOICE_NUMBER,
      purchase_id: this.invoice_data.PURCHASE_ID,
    };
    this.pricing_plan.purchase_id = this.invoice_data.PURCHASE_ID;
    this.loaderService.display(true);
    this.consultingService.listPurchaseItems(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.item_list = result['data'];
        let i = 0;
        for (const val of this.item_list) {
          this.pricing_plan.medicine_ids[i] = val.MEDICINE_ID;
          this.pricing_plan.unitprice[i] = parseFloat(val.UNIT_PRICE) + parseFloat(val.ONE_ITEM_FREIGHT_CHARGE);
          this.pricing_plan.sellingprice[i] = val.MRP;
          this.pricing_plan.rate[i] = parseFloat(val.RATE);
          this.pricing_plan.freight[i] = parseFloat(val.ONE_ITEM_FREIGHT_CHARGE);
          this.pricing_plan.vat[i] = parseFloat(val.VAT);
          this.pricing_plan.purchase_details_id[i] = val.PURCHASE_DETAILS_ID
          this.pricing_plan.slab_a_per[i] = val.SLAB_A
          this.pricing_plan.slab_b_per[i] = val.SLAB_B
          this.pricing_plan.slab_c_per[i] = val.SLAB_C
          this.pricing_plan.slab_a_amount[i] = Math.round(val.SLAB_A_AMOUNT)
          this.pricing_plan.web_per[i] = val.WEB
          this.pricing_plan.web_amount[i] = Math.round(val.WEB_AMOUNT)
          this.pricing_plan.slab_b_amount[i] = Math.round(val.SLAB_B_AMOUNT)
          this.pricing_plan.slab_c_amount[i] = Math.round(val.SLAB_C_AMOUNT)
          if (val.FLOOD_CESS > 0) {
            this.pricing_plan.flood[i] = val.FLOOD_CESS
          } else {
            this.pricing_plan.flood[i] = (parseFloat(this.pricing_plan.unitprice[i]) * environment.FLOOD_CESS_PERCENTAGE / 100).toFixed(2)
          }
          i = i + 1;
        }
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.item_list = []
      }
    });
  }

  public calculateSlabRates() {
    this.pricing_plan.purchase_details_id.forEach((_item: any, index: any) => {
      let temp;
      const vat = parseFloat(this.pricing_plan.vat[index])
      const rate = parseFloat(this.pricing_plan.unitprice[index])
      const slaba = parseFloat(this.pricing_plan.slab_a_per[index])
      const slabb = parseFloat(this.pricing_plan.slab_b_per[index])
      const slabc = parseFloat(this.pricing_plan.slab_c_per[index])
      const web = parseFloat(this.pricing_plan.web_per[index])
      const flood = (rate * environment.FLOOD_CESS_PERCENTAGE / 100);
      if (!isNaN(slaba)) {
        temp = (rate + (rate * slaba / 100));
        const a_amount = Math.round((temp + (temp * vat / 100)));
        this.pricing_plan.slab_a_amount[index] = a_amount + Math.round(flood)
        this.pricing_plan.slab_a_flood[index] = a_amount + flood
      }
      if (!isNaN(slabb)) {
        temp = (rate + (rate * slabb / 100));
        this.pricing_plan.slab_b_amount[index] = Math.round((temp + (temp * vat / 100)) + flood)
        this.pricing_plan.slab_b_flood[index] = Math.round((temp + (temp * vat / 100))) + flood
      }
      if (!isNaN(slabc)) {
        temp = (rate + (rate * (slabc / 100)));
        this.pricing_plan.slab_c_amount[index] = Math.round((temp + (temp * vat / 100)) + flood)
        this.pricing_plan.slab_c_flood[index] = Math.round((temp + (temp * vat / 100))) + flood
      }
      if (!isNaN(web)) {
        temp = (rate + (rate * (web / 100)));
        this.pricing_plan.web_amount[index] = Math.round((temp + (temp * vat / 100)) + flood)
      }
    });
  }

  public saveSlabDetails(): any {
    let rel = 1;
    this.pricing_plan.purchase_details_id.forEach((_item: any, index: any) => {
      const unitprice = parseFloat(this.pricing_plan.unitprice[index]);
      const rate = parseFloat(this.pricing_plan.rate[index])
      if (rate != unitprice) {
        rel = 0;
      }
    });
    if (rel == 0) {
      this.toastr.error("Cannot update rate price");
      return false;
    } else {
      this.loaderService.display(true);
      this.consultingService.saveSlabDetails(this.pricing_plan).subscribe((result: any) => {
        window.scrollTo(0, 0)
        if (result["status"] == "Success") {
          this.loaderService.display(false);
          this.toastr.success(result.msg);

        } else {
          this.toastr.error(result.msg);
          this.loaderService.display(false);
        }
      })
    }

  }

  getInvoice() {
    this.pricing_plan = {
      purchase_id: 0,
      invoice_no: '',
      medicine_ids: [""],
      medicine_id: 0,
      unitprice: [""],
      sellingprice: [""],
      slab_a_per: [""],
      slab_a_amount: [""],
      slab_b_per: [""],
      slab_b_amount: [""],
      flood: [""],
      slab_c_per: [""],
      slab_c_amount: [""],
      web_per: [""],
      web_amount: [""],
      user_id: '',
      vat: [""],
      slab_a_flood: [""],
      slab_b_flood: [""],
      slab_c_flood: [""],
      purchase_details_id: [],
      rate: [""],
      freight: [""],
      search_text: ""
    }
    this.pricing_plan.purchase_id = this.invoice_data.PURCHASE_ID;
    this.pricing_plan.invoice_no = this.invoice_data.INVOICE_NUMBER;
    this.listPurchaseItems();
  }

  public listAllItems() {

    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listAllItems().subscribe((result: any) => {
      if (result['status'] == 'success') {
        this.discount_list = result['data'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public round(data: any) {
    return Math.round(data)
  }

  public open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: " custom",
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  public listPurchaseItemsByVendor() {
    const postData = {
      search_text: this.pricing_plan.search_text
    };
    this.loaderService.display(true);
    this.consultingService.listPurchaseItemsByVendor(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.item_list = result['data'];
        let i = 0;
        for (const val of this.item_list) {
          this.pricing_plan.medicine_ids[i] = val.MEDICINE_ID;
          this.pricing_plan.unitprice[i] = parseFloat(val.UNIT_PRICE) + parseFloat(val.ONE_ITEM_FREIGHT_CHARGE);
          this.pricing_plan.sellingprice[i] = val.MRP;
          this.pricing_plan.freight[i] = parseFloat(val.ONE_ITEM_FREIGHT_CHARGE);
          this.pricing_plan.rate[i] = parseFloat(val.RATE);
          this.pricing_plan.vat[i] = parseFloat(val.VAT);
          this.pricing_plan.purchase_details_id[i] = val.PURCHASE_DETAILS_ID
          this.pricing_plan.slab_a_per[i] = val.SLAB_A
          this.pricing_plan.slab_b_per[i] = val.SLAB_B
          this.pricing_plan.slab_c_per[i] = val.SLAB_C
          this.pricing_plan.slab_a_amount[i] = Math.round(val.SLAB_A_AMOUNT)
          this.pricing_plan.web_per[i] = val.WEB
          this.pricing_plan.web_amount[i] = Math.round(val.WEB_AMOUNT)
          this.pricing_plan.slab_b_amount[i] = Math.round(val.SLAB_B_AMOUNT)
          this.pricing_plan.slab_c_amount[i] = Math.round(val.SLAB_C_AMOUNT)
          if (val.FLOOD_CESS > 0) {
            this.pricing_plan.flood[i] = val.FLOOD_CESS
          } else {
            this.pricing_plan.flood[i] = (parseFloat(this.pricing_plan.unitprice[i]) * environment.FLOOD_CESS_PERCENTAGE / 100).toFixed(2)
          }
          i = i + 1;
        }
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.item_list = []
      }
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
